import React from "react";
import { ComponentType } from "react";

import { StatusType } from "../../models";
import { getDeliveryStatusTypes } from "../../selectors";

export interface InjectedStatusTypesProps {
    statusTypes: StatusType[];
}

export const withStatusTypes = <P extends InjectedStatusTypesProps>(
    WrappedComponent: ComponentType<P>,
) => {
    return (props: Pick<P, Exclude<keyof P, keyof InjectedStatusTypesProps>>) => (
        <WrappedComponent {...props as P} statusTypes={getDeliveryStatusTypes(null)} />
    );
};
